import { Component, Input, OnInit, Output, EventEmitter, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { ThreeDotsMenuItem } from '../three-dots-menu-item';
import { InterfaceListenerService } from '@core/services/interface-listener/interface-listener.service';

@Component({
    selector: 'core-helpers-navigation-three-dots-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss']
})
export class HelperNavigationThreeDotsMenuComponent implements OnInit, OnDestroy {
    private readonly MENU_REMOVE_WITH_CONFIRM = "confirmation-remove";
    private readonly MENU_REALLY_REMOVE = "really-remove";
    private readonly MENU_DISMISS_REMOVE = "dismiss-really-remove";
    // @Input() session: any;
    @Input() menu: Array<ThreeDotsMenuItem> = [];
    @Input() dispatched: boolean;

    @Output() action = new EventEmitter<string>();

    public open: boolean = false;
    public itemMouseDown: boolean = false;
    private wasInside: boolean = false;


    protected docClickSusbs: Subscription[] = [];

    constructor(private iListenerSrv: InterfaceListenerService, private cdr: ChangeDetectorRef){

    }

    ngOnInit(): void {
        this.docClickSusbs.push(
            this.iListenerSrv.getDocuementClicked$().subscribe((value: any ) => {
                // this listen all clicks in the document, so we need to check what was ours
                if(this.open && !this.wasInside){
                    this.open = false;
                    this.cdr.markForCheck();
                    if(this.menu.some((mi:ThreeDotsMenuItem) => mi.key === this.MENU_REALLY_REMOVE))
                        this.action.emit(this.MENU_DISMISS_REMOVE);
                } else {
                    this.wasInside = false;
                }
            })
        )
    }

    // this is the only click that is really inside to open, 
    toggleOpen(event: any){
        this.open = !this.open;
        this.wasInside = true;
    }

    onClick(key: string, event: any) {
        if(key === this.MENU_REMOVE_WITH_CONFIRM)
            return;
        this.action.emit(key);
        this.open = false;
        this.wasInside = false;
        event.stopPropagation();
    }

    startClick(key: string, event: any) {
        if(key === this.MENU_REMOVE_WITH_CONFIRM)
            this.itemMouseDown = true;
        event.stopPropagation();
    }

    endClick(key: string, event: any) {
        if(key === this.MENU_REMOVE_WITH_CONFIRM){
            this.itemMouseDown = false;
            this.action.emit(key);
        }
        event.stopPropagation();
        
    }

    ngOnDestroy(): void {
        this.docClickSusbs.forEach((sub: Subscription) => sub.unsubscribe());
    }

}
